<script setup lang="ts">
import { FormSchema } from '@/@types/participant'
import { Input } from '@/components/ui/input'
import Label from '@/components/ui/label/Label.vue'

defineProps<{ form: FormSchema }>()
</script>

<template>
    <fieldset>
        <legend class="mb-4 font-sans text-lg font-semibold text-gray-800">
            {{ $t('Basic information') }}
        </legend>

        <div class="flex flex-col gap-1.5">
            <Label required for="badge_name">{{ $t('Name for badge') }}</Label>
            <Input type="text" id="badge_name" v-model="form.badge_name" :placeholder="$t('Name for badge')" />
            <p v-if="form.errors.badge_name" class="text-destructive text-xs">
                {{ form.errors.badge_name }}
            </p>
        </div>
    </fieldset>
</template>
